import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, withStyles } from '@material-ui/core';
import Modal from '../Modal';

const styles = {
    noteField: {
        width: '100%',
        '& > div > textarea': {
            lineHeight: '1.1'
        },
        '& .MuiOutlinedInput-root': {
            height: 'auto'
        }
    }
};

const EditNoteModal = ({ classes, isOpen, onClose, onUpdate, initialValue, noteType, noteId }) => {
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (isOpen) {
            setDescription(initialValue || '');
        }
    }, [isOpen, initialValue]);

    const handleUpdate = () => {
        onUpdate({ noteType, noteId, newDescription: description });
    };

    return (
        <Modal
            id="edit-note-modal"
            isOpen={isOpen}
            size="sm"
            onCancel={onClose}
            onClose={onClose}
            onConfirm={handleUpdate}
            title="Edit Note"
            confirmLabel="Update"
            disableConfirmButton={!description.trim()}
            disableBackdropClick
        >
            <TextField
                autoFocus
                multiline
                rows="4"
                variant="outlined"
                label="Note"
                margin="normal"
                value={description}
                onChange={e => setDescription(e.target.value)}
                className={classes.noteField}
            />
        </Modal>
    );
};

EditNoteModal.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    initialValue: PropTypes.string,
    noteType: PropTypes.oneOf(['description', 'modify']),
    noteId: PropTypes.string
};

export default withStyles(styles)(EditNoteModal);
